import {
  trackPageInteraction,
  trackPageLoad,
} from "@asosteam/asos-content-web-analytics";
import sdkProvider from "./sdk-provider";
import analyticsProvider from "../../analyticsProvider";
import getUserLoginStatus from "./getUserLoginStatus";
import { isNativeApp } from "../components/enter-form/utilities";

/* eslint-disable complexity */
export const trackPageEvent = async ({ content = {} }) => {
  try {
    const { layout } = content;
    const identity = await sdkProvider("identity");
    const isRecognised = (await identity.customer.isRecognised?.()) || false;
    const isAuthenticated = await identity.customer.isAuthenticated();
    const customerId = await identity.customer.customerId();
    const { platform = "", storeId = "" } =
      window.asos.webContext.getWebContext();
    const server = `${platform} ${storeId.toLowerCase()}`;
    const pageLoadProperties = {
      server,
      customerId,
      loginStatus: getUserLoginStatus({ isRecognised, isAuthenticated }),
      extraProps: {},
    };

    if (layout === "limited-drops-page-load") {
      const { sProp29Value } = content;
      pageLoadProperties.extraProps.prop29 = sProp29Value;
      const params = new URLSearchParams(window.location.search);
      const appPlatform = params.get("app_platform");
      const clickSource = params.get("click_source");
      if (isNativeApp() && clickSource) {
        pageLoadProperties.extraProps.prop6 = `${appPlatform} - ${clickSource} - limited drops`;
      }

      const config = analyticsProvider(layout, pageLoadProperties);
      await trackPageLoad(config);
    }

    if (layout === "limited-drops-message") {
      const { message } = content;
      pageLoadProperties.message = message;

      const config = analyticsProvider(layout, pageLoadProperties);
      await trackPageInteraction(config);
    }
  } catch (e) {
    throw new Error(e);
  }
};
